import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

export default function GraficoConsumo(props) {
    const { data, cor } = props;
    const [chartOptions, setChartOptions] = useState({});
    const [chartData, setChartData] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);

        const textColor = documentStyle.getPropertyValue('--text-color');

        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');

        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        
        const renderCor = () =>{
            switch(cor){
                case 'CIANO': return '#1565C0'
                case 'MAGENTA': return '#D81B60'
                case 'AMARELO': return '#FFB300'
                case 'PRETO': return '#000'
            }
        }

        const chartData = {
            labels: data.map((item) => item.datalog),
            datasets: [
                {
                    label: cor,
                    data: data.map((item) => item.nivel),
                    fill: true,
                    tension: 0.4,
                    borderColor: renderCor()
                }
            ]
        };

        const options = {
            maintainAspectRatio: false, // ✅ ESSENCIAL
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    min: 0, // valor mínimo fixo
                    max: 100, // valor máximo fixo        
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setChartData(chartData);
        setChartOptions(options);
    }, [data, cor]); // Inclua data e cor como dependências para re-renderizar quando mudar

    return (
        <div className="card" style={{height : '250px'}}>
            <Chart type="line" data={chartData} options={chartOptions} style={{height : '100%'}} />
        </div>
    )
}
